import React, {createContext, useContext, useState} from "react";
import {getOrders} from "./crud/factorCrud";
import {useQuery} from "../../../_metronic/_helpers/SearchParams";

const FactorsUIContext = createContext();

export function useFactorsUIContext() {
    return useContext(FactorsUIContext);
}

export function FactorsUIProvider({children}) {

    const [id, setId] = useState(0);
    const [order, setOrder] = useState({
        id: 0,
        status: {
            id: 0,
            name: ''
        },
        status_id: 0,
        product_id: 0,
        bascket_id: 0,
        factor_id:0,
        price: 0,
        quantity: 0,
        product: {
            trendyolUrl: ''
        }
    });
    const [photos, setPhotos] = useState([]);
    const [statuses, setStatuses] = useState([]);
    const [factors, setFactors] = useState([]);
    const [openEdit, setOpenEdit] = useState(false);
    const [openDelete, setOpenDelete] = useState(false);
    const [openError, setOpenError] = useState(false);
    const [error, setError] = useState('');
    const [data, setData] = useState({});
    let query = useQuery();

    const fetchData = () => {
        const page = query.get("page") ? query.get("page") : 1;
        const limit = query.get("limit") ? query.get("limit") : '';
        getOrders(page, limit)
            .then((response) => {
                setData(response.data.data);
            }).catch(err => console.log(err));
    };

    const handleEdit = id => {
        setOpenEdit(true);
        setId(id);
    };

    const handleDelete = id => {
        setOpenDelete(true);
        setId(id);
    };

    const value = {
        photos,
        setPhotos,
        order,
        setOrder,
        openError,
        setOpenError,
        error,
        setError,
        openEdit,
        setOpenEdit,
        openDelete,
        setOpenDelete,
        id,
        setId,
        handleDelete,
        handleEdit,
        fetchData,
        statuses,
        setStatuses,
        setFactors,
        factors,
        data,
        setData
    };

    return <FactorsUIContext.Provider value={value}>{children}</FactorsUIContext.Provider>;
}